import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // For validation
import { getAllAgentsService } from "../../../../services/agentService";
import { toast } from "react-toastify";
import { createLoanService } from "../../../../services/loanService";
import useStore from "../../../../useStore";

// Validation Schema
// Validation Schema
const LoanSchema = Yup.object().shape({
  agent: Yup.string().required("Agent is required"),
  loanAmount: Yup.number().required("Loan Amount is required"),
  frequency: Yup.string().required("Frequency is required"),
  startDate: Yup.date().required("Start Date is required"),
  collectionDay: Yup.string(),
  endDate: Yup.date().required("End Date is required"),
  processingFee: Yup.number().required("Processing Fees is required"),
  interestAmount: Yup.number().required("Interest Amount is required"),
  loanTenure: Yup.string().required("Loan Tenure is required"),
  amountToBePaidBy: Yup.string().required("Amount to be paid by is required"), // Validation for missing field
  disbursedAmount: Yup.number().required("Disbursed Amount is required"),
  collectionAmount: Yup.number().required("Collection Amount is required"),
  interest: Yup.number().required("Interest is required"), // Validation for missing field
  insuranceFee: Yup.number(),
  penaltyAmount: Yup.number(),
  overDueInterest: Yup.number().required("Interest is required"),
  totalLoanAmount: Yup.number(),
});

const CreateLoanModal = ({ open, onClose, id }) => {
  const [agents, setAgents] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { setLoanSubmit } = useStore();

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
    } catch (err) {
      toast.error(err.message);
    }
  };
  const calculateCollectionAmount = (values, tenure) => {
    if (values.loanAmount) {
      const collectionAmount = values.loanAmount / tenure;

      return { amount: Math.round(collectionAmount) }; // Round to the nearest whole number
    }
    return { amount: 0 }; // Return 0 if loanAmount is not provided
  };
  const calculateLoanCollectionAmount = (values, loanAmount) => {
    if (values.loanTenure) {
      const collectionAmount = loanAmount / values.loanTenure;

      return { amount: Math.round(collectionAmount) }; // Round to the nearest whole number
    }
    return { amount: 0 }; // Return 0 if loanAmount is not provided
  };

  const calculateInterestAndCollection = (values) => {
    if (values.loanAmount) {
      const totalAmount = (values.loanAmount * values.interest) / 100;
      const totalInterestAmount = totalAmount * values.loanTenure;
      const collectionAmount =
        (totalInterestAmount + values.loanAmount) / values.loanTenure;
      return { amount: Math.round(collectionAmount), totalInterestAmount };
    }
  };

  const calculateInterest = (values) => {
    const collectionAmount = (values.loanAmount * values.interest) / 100;
    // const collectionAmount = InterestAmount / values.loanTenure;
    return { amount: Math.round(collectionAmount) };
  };

  const calculateEndDate = (values, frequency) => {
    let startDate = new Date();
    let endDate = new Date(startDate); // Copy startDate

    if (frequency === "daily") {
      // Manually set the date to ensure consistent day handling
      endDate.setDate(startDate.getDate() + values?.loanTenure);
    } else if (frequency === "weekly") {
      endDate.setDate(startDate.getDate() + values?.loanTenure * 7);
    } else if (frequency === "monthly") {
      // Use setMonth to ensure correct day handling for monthly frequencies
      endDate.setMonth(startDate.getMonth() + values?.loanTenure);

      // Ensure that the day of the month stays consistent
      if (startDate.getDate() !== endDate.getDate()) {
        // If the month change pushes it to the next month (e.g., from 31st to 1st),
        // we manually set the date to match the start date.
        endDate.setDate(startDate.getDate());
      }
    }

    // Return consistent date formats
    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  const handleSubmit = async (values) => {
    console.log("hi");
    setIsSubmitting(true);
    setLoanSubmit(false);
    try {
      console.log(values?.frequency, values?.penaltyAmount);
      if (
        (values?.frequency === "daily" || values?.frequency === "weekly") &&
        values?.penaltyAmount === 0
      ) {
        toast.error("Penalty Amount Should Be Greater Than O");
      } else {
        const payload = { ...values, user: id };
        await createLoanService(payload);
        toast.success("Loan created successfully!");
        onClose();
      }
      // Include user ID with the form values
    } catch (error) {
      toast.error("Failed to create Loan");
    } finally {
      setIsSubmitting(false);
      setLoanSubmit(true);
    }
  };
  const handleStartDate = (values, date) => {
    let startDate = new Date(date);
    let endDate = new Date(startDate); // Copy startDate

    if (values?.frequency === "daily") {
      endDate.setDate(startDate.getDate() + Number(values?.loanTenure));
    } else if (values?.frequency === "weekly") {
      endDate.setDate(startDate.getDate() + Number(values?.loanTenure) * 7);
    } else if (values?.frequency === "monthly") {
      console.log(endDate);
      console.log(startDate.getMonth() + Number(values?.loanTenure));
      endDate.setMonth(startDate.getMonth() + Number(values?.loanTenure));
      console.log(endDate);
      if (startDate.getDate() !== endDate.getDate()) {
        endDate.setDate(startDate.getDate());
      }
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };
  function calculateMonthsFromWeeks(weeks) {
    const weeksPerMonth = 4.345; // Approximate number of weeks in a month
    const months = weeks / weeksPerMonth;
    return Math.round(months); // Returns result rounded to the nearest whole number
  }
  function calculateMonthsFromDays(days) {
    const daysPerMonth = 30.44; // Average number of days in a month
    const months = days / daysPerMonth;
    return Math.round(months); // Returns result rounded to the nearest whole number
  }

  const calculateInterestChange = (interest, values) => {
    let months;
    if (values?.frequency === "weekly") {
      console.log("week");
      months = calculateMonthsFromWeeks(values.loanTenure);
    } else if (values?.frequency === "daily") {
      console.log("daily");
      months = calculateMonthsFromDays(values.loanTenure);
    }
    const collectionAmount = (values.loanAmount * interest) / 100;
    const interestAmount = collectionAmount * months;
    const disbursedAmount = values.loanAmount - interestAmount;
    return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  };
  const calculateInterestAndDisbursedAmount = (values, type) => {
    let months;
    if (type === "weekly") {
      console.log("week");
      months = calculateMonthsFromWeeks(values.loanTenure);
    } else if (type === "daily") {
      console.log("daily");
      months = calculateMonthsFromDays(values.loanTenure);
    }

    const collectionAmount = (values.loanAmount * values.interest) / 100;
    const interestAmount = collectionAmount * months;
    const disbursedAmount = values.loanAmount - interestAmount;
    return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  };
  const calculateInterestAndDisbursedAmount1 = (values, type) => {
    let months;
    if (values.frequency === "weekly") {
      console.log("week");
      months = calculateMonthsFromWeeks(values.loanTenure);
    } else if (values.frequency === "daily") {
      console.log("daily");
      months = calculateMonthsFromDays(values.loanTenure);
    }

    const collectionAmount = (type * values.interest) / 100;
    const interestAmount = collectionAmount * months;
    const disbursedAmount = type - interestAmount;
    return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Create Loan</DialogTitle>
      <Formik
        initialValues={{
          agent: "",
          loanAmount: "",
          frequency: "",
          collectionDay: "",
          startDate: null,
          endDate: null,
          processingFee: 0,
          interestAmount: 0,
          loanTenure: "",
          amountToBePaidBy: "",
          disbursedAmount: "",
          collectionAmount: "",
          interest: 5,
          insuranceFee: 0,
          penaltyAmount: 0,
          overDueInterest: Number,
          totalLoanAmount: 0,
        }}
        validationSchema={LoanSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, errors, touched }) => (
          <Form>
            <DialogContent>
              <Box
                sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}
              >
                {/* Agent Field */}
                <Box>
                  <Typography>Agent *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="agent"
                    select
                    fullWidth
                    error={touched.agent && Boolean(errors.agent)}
                    helperText={touched.agent && errors.agent}
                    required
                  >
                    {agents.map((agent) => (
                      <MenuItem key={agent._id} value={agent._id}>
                        {agent.userName}
                      </MenuItem>
                    ))}
                  </Field>
                </Box>

                {/* Loan Amount Field */}
                <Box>
                  <Typography>Loan Amount *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="loanAmount"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      const { amount } = calculateLoanCollectionAmount(
                        values,
                        e.target.value
                      );
                      setFieldValue("collectionAmount", amount);
                      const { interestAmount, disbursedAmount } =
                        calculateInterestAndDisbursedAmount1(
                          values,
                          e.target.value
                        );
                      setFieldValue("interestAmount", interestAmount);
                      setFieldValue("disbursedAmount", disbursedAmount);
                    }}
                    error={touched.loanAmount && Boolean(errors.loanAmount)}
                    helperText={touched.loanAmount && errors.loanAmount}
                    required
                  />
                </Box>

                {/* Loan Tenure Field */}
                <Box>
                  <Typography>Loan Tenure *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="loanTenure"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    error={touched.loanTenure && Boolean(errors.loanTenure)}
                    helperText={touched.loanTenure && errors.loanTenure}
                    required
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      const { amount } = calculateCollectionAmount(
                        values,
                        e.target.value
                      );
                      setFieldValue("collectionAmount", amount);
                      const { interestAmount, disbursedAmount } =
                        calculateInterestAndDisbursedAmount(
                          values,
                          values.frequency
                        );
                      console.log(interestAmount, disbursedAmount);
                      setFieldValue("interestAmount", interestAmount);
                      setFieldValue("disbursedAmount", disbursedAmount);
                    }}
                  />
                </Box>

                {/* Frequency Field */}
                <Box>
                  <Typography>Frequency *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="frequency"
                    select
                    fullWidth
                    error={touched.frequency && Boolean(errors.frequency)}
                    helperText={touched.frequency && errors.frequency}
                    required
                    onChange={(e) => {
                      handleChange(e);
                      const { startDate, endDate } = calculateEndDate(
                        values,
                        e.target.value
                      );
                      if (
                        e.target.value === "daily" ||
                        e.target.value === "weekly"
                      ) {
                        setFieldValue("amountToBePaidBy", "emi");
                        const { interestAmount, disbursedAmount } =
                          calculateInterestAndDisbursedAmount(
                            values,
                            e.target.value
                          );
                        console.log(interestAmount, disbursedAmount);
                        setFieldValue("interestAmount", interestAmount);
                        setFieldValue("disbursedAmount", disbursedAmount);
                      }
                      setFieldValue("startDate", startDate);
                      setFieldValue("endDate", endDate);
                    }}
                  >
                    <MenuItem value="daily">Daily</MenuItem>
                    <MenuItem value="weekly">Weekly</MenuItem>
                    <MenuItem value="monthly">Monthly</MenuItem>
                  </Field>
                </Box>
                {values?.frequency === "weekly" ? (
                  <Box>
                    <Typography>Collection Day *</Typography>
                    <Field
                      as={TextField}
                      size="small"
                      name="collectionDay"
                      select
                      fullWidth
                      error={
                        touched.collectionDay && Boolean(errors.collectionDay)
                      }
                      helperText={touched.collectionDay && errors.collectionDay}
                      required
                      onChange={(e) => {
                        handleChange(e);
                        // const { startDate, endDate } = calculateEndDate(
                        //   values,
                        //   e.target.value
                        // );
                        // setFieldValue("startDate", startDate);
                        // setFieldValue("endDate", endDate);
                      }}
                    >
                      <MenuItem value="monday">Monday</MenuItem>
                      <MenuItem value="tuesday">Tuesday</MenuItem>
                      <MenuItem value="wednesday">Wednesday</MenuItem>
                      <MenuItem value="thursday">Thursday</MenuItem>
                      <MenuItem value="friday">Friday</MenuItem>
                      <MenuItem value="saturday">Saturday</MenuItem>
                    </Field>
                  </Box>
                ) : null}

                {/* Interest Field */}
                <Box>
                  <Typography>Interest *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="interest"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: "any", // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    onChange={(e) => {
                      handleChange(e);
                      const { interestAmount, disbursedAmount } =
                        calculateInterestChange(e.target.value, values);
                      console.log(interestAmount, disbursedAmount);
                      setFieldValue("interestAmount", interestAmount);
                      setFieldValue("disbursedAmount", disbursedAmount);
                      if (values.amountToBePaidBy === "interest") {
                        setFieldValue("collectionAmount", interestAmount);
                        const disbursedAmount =
                          values.loanAmount - interestAmount;
                        setFieldValue("disbursedAmount", disbursedAmount);
                      }
                    }}
                    error={touched.interest && Boolean(errors.interest)}
                    helperText={touched.interest && errors.interest}
                    required
                  />
                </Box>
                {/* Amount to be Paid By Field */}
                <Box>
                  <Typography>Amount to be Paid By *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="amountToBePaidBy"
                    select
                    fullWidth
                    error={
                      touched.amountToBePaidBy &&
                      Boolean(errors.amountToBePaidBy)
                    }
                    helperText={
                      touched.amountToBePaidBy && errors.amountToBePaidBy
                    }
                    required
                    onChange={(e) => {
                      handleChange(e);
                      if (e.target.value === "interest") {
                        const { amount } = calculateInterest(values);
                        const disbursedAmount = values.loanAmount - amount;

                        setFieldValue("disbursedAmount", disbursedAmount);
                        setFieldValue("interestAmount", amount);
                        setFieldValue("collectionAmount", amount);
                      } else if (e.target.value === "interest+emi") {
                        const { amount, totalInterestAmount } =
                          calculateInterestAndCollection(values);

                        setFieldValue("collectionAmount", amount);
                        setFieldValue("disbursedAmount", values.loanAmount);
                        setFieldValue("interestAmount", totalInterestAmount);
                        setFieldValue(
                          "totalLoanAmount",
                          values.loanAmount + totalInterestAmount
                        );
                      } else {
                        const { amount } = calculateCollectionAmount(
                          values,
                          values.loanTenure
                        );
                        setFieldValue("collectionAmount", amount);
                      }
                    }}
                  >
                    {values.frequency === "monthly"
                      ? [
                          <MenuItem key="interest" value="interest">
                            Interest
                          </MenuItem>,
                          <MenuItem key="interest+emi" value="interest+emi">
                            Interest + EMI
                          </MenuItem>,
                        ]
                      : [
                          <MenuItem key="emi" value="emi">
                            EMI
                          </MenuItem>,
                        ]}
                  </Field>
                </Box>
                {values?.amountToBePaidBy === "interest+emi" ? (
                  <Box>
                    <Typography>Toal Loan Amount *</Typography>
                    <Field
                      as={TextField}
                      size="small"
                      name="totalLoanAmount"
                      type="number"
                      fullWidth
                      inputProps={{
                        min: 0, // Prevent negative numbers
                        step: 1, // Optional: Define step increment (if needed)
                        style: { appearance: "textfield" }, // Remove arrows for most browsers
                      }}
                      sx={{
                        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                          {
                            appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                            margin: 0,
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield", // Remove arrows for Firefox
                        },
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault(); // Prevent minus sign and "e"
                        }
                      }}
                      error={
                        touched.totalLoanAmount &&
                        Boolean(errors.totalLoanAmount)
                      }
                      helperText={
                        touched.totalLoanAmount && errors.totalLoanAmount
                      }
                      InputProps={{
                        readOnly: true, // Makes the field read-only
                      }}
                    />
                  </Box>
                ) : null}

                {/* Start Date Field */}
                <Box>
                  <Typography>Start Date *</Typography>
                  <Field
                    as={TextField}
                    name="startDate"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    onChange={(e) => {
                      handleChange(e);
                      const { startDate, endDate } = handleStartDate(
                        values,
                        e.target.value
                      );
                      setFieldValue("startDate", startDate);
                      setFieldValue("endDate", endDate);
                    }}
                    error={touched.startDate && Boolean(errors.startDate)}
                    helperText={touched.startDate && errors.startDate}
                    required
                  />
                </Box>

                {/* End Date Field */}
                <Box>
                  <Typography>End Date *</Typography>
                  <Field
                    as={TextField}
                    name="endDate"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    error={touched.endDate && Boolean(errors.endDate)}
                    helperText={touched.endDate && errors.endDate}
                    required
                    InputProps={{
                      readOnly: true, // Makes the field read-only
                    }}
                  />
                </Box>
                {/* Amount to be paid by Field */}

                {/* Processing Fees Field */}
                <Box>
                  <Typography>Processing Fees *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="processingFee"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    error={
                      touched.processingFee && Boolean(errors.processingFee)
                    }
                    helperText={touched.processingFee && errors.processingFee}
                    required
                  />
                </Box>

                {/* Interest Amount Field */}
                <Box>
                  <Typography>Interest Amount *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="interestAmount"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    error={
                      touched.interestAmount && Boolean(errors.interestAmount)
                    }
                    helperText={touched.interestAmount && errors.interestAmount}
                    required
                    InputProps={{
                      readOnly: true, // Makes the field read-only
                    }}
                  />
                </Box>

                {/* Disbursed Amount Field */}
                <Box>
                  <Typography>Disbursed Amount *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="disbursedAmount"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    error={
                      touched.disbursedAmount && Boolean(errors.disbursedAmount)
                    }
                    helperText={
                      touched.disbursedAmount && errors.disbursedAmount
                    }
                    required
                    InputProps={{
                      readOnly: true, // Makes the field read-only
                    }}
                  />
                </Box>

                {/* Collection Amount Field */}
                <Box>
                  <Typography>Collection Amount *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="collectionAmount"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    error={
                      touched.collectionAmount &&
                      Boolean(errors.collectionAmount)
                    }
                    helperText={
                      touched.collectionAmount && errors.collectionAmount
                    }
                    required
                    InputProps={{
                      readOnly: true, // Makes the field read-only
                    }}
                  />
                </Box>
                <Box>
                  <Typography>Insurance Fees *</Typography>
                  <Field
                    as={TextField}
                    size="small"
                    name="insuranceFee"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 0, // Prevent negative numbers
                      step: 1, // Optional: Define step increment (if needed)
                      style: { appearance: "textfield" }, // Remove arrows for most browsers
                    }}
                    sx={{
                      "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                        {
                          appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                          margin: 0,
                        },
                      "& input[type=number]": {
                        MozAppearance: "textfield", // Remove arrows for Firefox
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent minus sign and "e"
                      }
                    }}
                    error={
                      touched.processingFee && Boolean(errors.processingFee)
                    }
                    helperText={touched.processingFee && errors.processingFee}
                    required
                  />
                </Box>
                {values.frequency != "monthly" ? (
                  <Box>
                    <Typography>Penalty Amount *</Typography>
                    <Field
                      as={TextField}
                      size="small"
                      name="penaltyAmount"
                      type="number"
                      fullWidth
                      inputProps={{
                        min: 0, // Prevent negative numbers
                        step: 1, // Optional: Define step increment (if needed)
                        style: { appearance: "textfield" }, // Remove arrows for most browsers
                      }}
                      sx={{
                        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                          {
                            appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                            margin: 0,
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield", // Remove arrows for Firefox
                        },
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault(); // Prevent minus sign and "e"
                        }
                      }}
                      error={
                        touched.penaltyAmount && Boolean(errors.penaltyAmount)
                      }
                      helperText={touched.penaltyAmount && errors.penaltyAmount}
                      required
                    />
                  </Box>
                ) : (
                  <></>
                )}
              </Box>
              <Box>
                <Typography>Over Due Interest *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="overDueInterest"
                  type="number"
                  fullWidth
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  error={
                    touched.overDueInterest && Boolean(errors.overDueInterest)
                  }
                  helperText={touched.overDueInterest && errors.overDueInterest}
                  required
                />
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={onClose} color="inherit">
                Close
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Submit
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CreateLoanModal;
